/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         22/12/23 - 10:23 PM
 * Module name:  chart-bar-manager.constants
 * File name:    chart-bar-factory.constants.ts
 * IDE:          WebStorm
 */
import {PantoneBaseConst} from '../constants';
import {StatusDeviceInterface} from '../interface';

export const StatusDeviceKeyParse = (item: string): keyof StatusDeviceInterface => {
  return item as keyof StatusDeviceInterface;
};

export enum StatusDeviceKeysEnum {
  comm = 'comm',
  danger = 'danger',
  warning = 'warning',
  alert = 'alert',
  success = 'success'
}

export const StatusDeviceColorConst: Record<StatusDeviceKeysEnum, string> = {
  [StatusDeviceKeysEnum.comm]: PantoneBaseConst.comm,
  [StatusDeviceKeysEnum.success]: PantoneBaseConst.success,
  [StatusDeviceKeysEnum.alert]: PantoneBaseConst.alert,
  [StatusDeviceKeysEnum.warning]: PantoneBaseConst.warning,
  [StatusDeviceKeysEnum.danger]: PantoneBaseConst.danger
};

export const StatusDeviceTextConst: Record<StatusDeviceKeysEnum, string> = {
  [StatusDeviceKeysEnum.comm]: 'Communication',
  [StatusDeviceKeysEnum.success]: 'Success',
  [StatusDeviceKeysEnum.alert]: 'Alert',
  [StatusDeviceKeysEnum.warning]: 'Warning',
  [StatusDeviceKeysEnum.danger]: 'Danger'
};
